import {axiosInstance} from "../lib/axios";

class AdminTransactionService {
  async list(params = {}) {
    const {data} = await axiosInstance.get("/admins/transactions", {params});
    return data;
  }

  async getById(id) {
    const {data} = await axiosInstance.get(`/admins/transactions/${id}`);
    return data;
  }
}

export const adminTransactionService = new AdminTransactionService();
